import { useCallback } from 'react';

import type { HGPokerGameTile } from '../types/common';

export interface Props {
  link: HGPokerGameTile['link'];
  id: HGPokerGameTile['id'];
  clubId: HGPokerGameTile['clubId'];
}

const useOpenEmbeddedGame = ({ id, clubId, link }: Props) => {
  const handleEmbeddedGame = useCallback(() => {
    const starsWeb = window.starsweb;

    if (link === 'joinTable') {
      starsWeb?.homegames?.openTable({ tableId: id, clubId });
      return;
    } else if (link === 'joinTourn') {
      starsWeb?.homegames?.openTourn({ tournId: id, clubId });
      return;
    }
  }, [id, clubId, link]);

  return handleEmbeddedGame;
};

export default useOpenEmbeddedGame;
